module.exports = __webpack_public_path__ + "static/media/alarm.ddd35769.mp3";